module.exports = __webpack_public_path__ + "static/media/pikachu_0.e9ec2df6.png";